export default {
  title: 'Tire Rack Scorecard',
  info: 'Each column shows the Tire Rack claims created in that month, by their current status, so recent months change as claims close. Paid %, Denied % and CWOP % are shares of processed claims (closed, excluding cancelled). Cycle times are whole days from claim creation to payment or denial. A dash means no data or nothing to measure, not zero.',
  notAvailable: 'The Tire Rack Scorecard is available only to Tire Rack accounts.',
  loading: 'Loading Tire Rack Scorecard…',
  noData: 'No data was returned for this date range.',
  retry: 'Retry',
  error: {
    failed: 'Unable to load the Tire Rack Scorecard. Please try again.',
    forbidden: 'You do not have permission to view this report.',
  },
  range: {
    label: 'Date Range',
    last3Months: 'Last 3 Months',
    last6Months: 'Last 6 Months',
    last12Months: 'Last 12 Months',
    yearToDate: 'Year to Date',
    custom: 'Custom',
    startMonth: 'Start Month',
    endMonth: 'End Month',
    apply: 'Apply',
    invalid: 'Choose a start month on or before the end month, covering at most 120 months.',
  },
  cwop: {
    title: 'CWOP Root Cause',
    caption: 'Count (share of the month\'s CWOP). A claim is closed without payment after 31 days without a new document, so the latest month or two are still filling in.',
    noInstallation: 'No installation documentation received',
    noPurchase: 'No replacement purchase documentation received',
    noDocumentation: 'No replacement or installation documentation received',
    other: 'Other / not determined',
  },
  metrics: {
    title: 'Metric',
    caption: 'Claims grouped by creation month (UTC), by current status.',
    created: 'Claims Created',
    paid: 'Claims Paid',
    denied: 'Claims Denied',
    pending: 'Claims Pending',
    cwop: 'Claims CWOP',
    paidPercent: 'Paid %',
    deniedPercent: 'Denied %',
    cwopPercent: 'CWOP %',
  },
  cycle: {
    title: 'Average Claim Cycle',
    average: 'Average Claim Cycle Time (average days from open to close)',
    repair: 'Repair',
    replace: 'Replace',
    within5Days: '% Resolved within 5 days',
  },
  dash: {
    unavailable: 'Unavailable',
    noProcessedClaims: 'No processed claims',
    noResolvedClaims: 'No paid or denied claims resolved',
    noQualifyingClaims: 'No qualifying resolved claims',
  },
};
